import { call, put, select } from "redux-saga/effects";
import cirrusClient from "../../../services/api/cirrus-client";
import { removeIncomingCallSaga } from "../../callSessions/removeIncomingCall/removeIncomingCall"
import { selectUserCredentials } from "../../../state/userCredential/userCredentialSlice";

export function* rejectCallSaga(action) {

    const callSession = action.payload;
    const { uid } = yield select(selectUserCredentials);

    try {
        callSession.reject();

        // Remove the call from incomingCalls
        yield call(removeIncomingCallSaga, { payload: callSession.id });

        const callId = callSession.id.replace(callSession.from_tag, '') 

        // API endpoint for rejecting call on all system 
        const apiUrl = '?object=call&action=reject';
        // Parameters for the API call
        const params = {
            callid: callId,
            uid: uid,
        }
        // Make the API call with the credentials
        const response = yield call(cirrusClient.get, apiUrl, { params });
        console.log("Call rejected successfully");
    } catch (error) {
        console.error("Error rejecting call:", error);
    }

}